import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useGlobalContext } from '@/store';

export function ConfirmModal() {
  const { confirmModal, closeConfirmModal } = useGlobalContext();

  const handleConfirm = () => {
    confirmModal.handleConfirm();
    closeConfirmModal();
  };

  return (
    <Dialog open={confirmModal.show} onClose={closeConfirmModal} maxWidth="xs" fullWidth>
      <DialogTitle>{confirmModal.title}</DialogTitle>
      <DialogContent>
        <Typography>{confirmModal.message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeConfirmModal} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
